var React = require('react');

function CartActive (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.34973 5.83333H24.5L22.1667 14H8.60616M23.3333 18.6667H9.33333L7 3.5H3.5M10.5 23.3333C10.5 23.9777 9.97767 24.5 9.33333 24.5C8.689 24.5 8.16667 23.9777 8.16667 23.3333C8.16667 22.689 8.689 22.1667 9.33333 22.1667C9.97767 22.1667 10.5 22.689 10.5 23.3333ZM23.3333 23.3333C23.3333 23.9777 22.811 24.5 22.1667 24.5C21.5223 24.5 21 23.9777 21 23.3333C21 22.689 21.5223 22.1667 22.1667 22.1667C22.811 22.1667 23.3333 22.689 23.3333 23.3333Z","stroke":"#121212","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CartActive.defaultProps = {"width":"24","height":"24","viewBox":"0 0 28 28","fill":"none"};

module.exports = CartActive;

CartActive.default = CartActive;
